import React from 'react';
import Card from '@/components/UI/Card';

interface DetailItem {
  label: string;
  value: string | number | undefined | null;
  render?: () => React.ReactNode;
}

interface DetailsCardProps {
  title?: string | undefined;
  userName?: string | undefined;
  details: DetailItem[];
  columns?: number;
  customerSince?: string;
}

const DetailsCard: React.FC<DetailsCardProps> = ({
  title,
  userName,
  details,
  columns = 2,
  customerSince,
}) => {
  return (
    <Card>
      <div className="flex justify-between">
        {title && <h3 className="text-base text-black mb-5">{title}</h3>}
        {userName && <h3 className="text-3xl text-black mb-5">{userName}</h3>}
        {customerSince ? (
          <div className="text-sm text-gray-300">{customerSince}</div>
        ) : (
          ''
        )}
      </div>
      <div
        className={`grid grid-cols-1 sm:grid-cols-${columns} text-sm gap-x-4 gap-y-5`}
      >
        {details.map((item, index) => (
          <div key={index} className="text-sm text-gray-300">
            <h5 className="font-medium mb-2 text-black">{item.label}:</h5>

            {item.render ? item.render() : item.value || '--'}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default DetailsCard;
